const defaultAggProps = {
  /** skeleton tailor */
  siteBoundaryFactor: 0.95,
  avoidNorthFactor: 0,
  avoidNorthRange: 22.5,
  adjacencyFactor: 0.8,
  disableTBranches: true,
  maxWingLength: 100,
  /** subdivision */
  maxPlotCount: 100,
  minWidth: 34.95,
  // building width: (corridor + 2 * module depth) 2m + 2 * 7.475m = 16.95m, allowing for 18m padding (building separation) = 16.95m + 18m = 34.95m
  minArea: 34.95 * 50,
  // = 1700, approx. smallest building dims. Where 50 is reasonable length
  maxLength: 100,
  // limit buildings to approx 100m length
  allowLongitudinalSplit: true
};
export {
  defaultAggProps
};
//# sourceMappingURL=index233.js.map
